import { cn } from "./utils";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import * as React from "react";

const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
            "peer data-[state=checked]:bg-indigo-600 dark:data-[state=checked]:bg-indigo-50 disabled:opacity-50 border border-indigo-600 dark:border-indigo-50 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-950 dark:focus-visible:ring-indigo-300 ring-offset-white focus-visible:ring-offset-2 dark:ring-offset-indigo-950 w-6 h-6 data-[state=checked]:text-indigo-50 dark:data-[state=checked]:text-indigo-900 disabled:cursor-not-allowed shrink-0",
            className
        )}
        {...props}
    >
        <CheckboxPrimitive.Indicator className={cn("flex justify-center items-center text-current")}>
            <Check strokeWidth={3} size={20} />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
